import React from "react";

const ArrowLeft = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.157" height="26.561" viewBox="0 0 14.157 26.561">
        <path
            id="arraow_left"
            data-name="arraow left"
            d="M5262.124-164.889l-10-11.668,10-12.332"
            transform="translate(-5249.52 190.149)"
            fill="none" stroke="#aaa081"
            stroke-width="4"/>
    </svg>

);

export default ArrowLeft;
